export default "__VITE_ASSET__ZDMO27YR__"